let flashTimer: number | undefined
let flashingTarget: HTMLElement | null = null

function findPermissionDebugTarget(id: string): HTMLElement | null {
  return Array.from(document.querySelectorAll<HTMLElement>('[data-permission-debug-id]'))
    .find((element) => element.dataset.permissionDebugId === id) ?? null
}

export function flashPermissionDebugTarget(id: string): boolean {
  const marker = findPermissionDebugTarget(id)
  if (!marker) return false

  const target = marker.firstElementChild instanceof HTMLElement ? marker.firstElementChild : marker
  if (flashTimer !== undefined) window.clearTimeout(flashTimer)
  flashingTarget?.removeAttribute('data-permission-debug-flash')

  target.removeAttribute('data-permission-debug-flash')
  void target.offsetWidth
  target.setAttribute('data-permission-debug-flash', 'true')
  target.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'nearest' })
  flashingTarget = target
  flashTimer = window.setTimeout(() => {
    target.removeAttribute('data-permission-debug-flash')
    if (flashingTarget === target) flashingTarget = null
  }, 1_600)

  return true
}
